import { appServiceApi } from "../../../app/appServiceApi";
import { EMP_API } from "../../../constants/apiUrl";
import { GetQueryArgsType, PatchQueryArgsType } from "../../../types";
import {
  EmployeesListExportParams,
  GetBusinessDataResponseType,
  GetDisbursementBankKeywordsParamsType,
  GetDisbursementBankKeywordsResponseType,
  GetDownloadSalaryCertificateType,
  GetEmployeeBreakdownSalaryDetailsResponseType,
  GetEmployeeDetailsResponseType,
  GetEmployeeManagementDataParamsType,
  GetEmployeeManagementDataResponseType,
  GetEmployeeParamsType,
  GetEmployeesListExportResponseType,
  GetEmployeesResponseType,
  GetGradeResponseType,
  GetPayComponentParamsType,
  GetRoleStatusResponseType,
  GetUserDetailsLog,
  GetUserDetailsLogParams,
  PayrollComponentResponseType,
  PayrollSettingResponseType,
} from "./employee.type";

export const employeeApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployees: builder.query<
      GetEmployeesResponseType,
      GetQueryArgsType<GetEmployeeParamsType>
    >({
      query: (queryArgs) => ({
        url: EMP_API.getEmployees,
        ...queryArgs,
      }),
      providesTags: ["GetEmployees"],
    }),
    getEmployeeDetails: builder.query<GetEmployeeDetailsResponseType, string>({
      query: (id) => ({
        url: `${EMP_API.getEmployeeDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetEmployeeDetails", id }],
    }),
    getMe: builder.query<GetEmployeeDetailsResponseType, void>({
      query: () => ({
        url: EMP_API.getMe,
      }),
      providesTags: () => [{ type: "GetEmployeeDetails" }],
    }),
    addEmployee: builder.mutation({
      query: (data) => ({
        url: EMP_API.addEmployee,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        // GS-4 Start
        if (result) return ["GetGrade", "GetUsers"];
        // GS-4 End
        return [];
      },
    }),
    updateProfilePicture: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateProfilePicture}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeOfficialData: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeeOfficialData}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            "GetGrade",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeePersonalData: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeePersonalData}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetEmployees",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeFinancialData: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeeFinancialData}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeSalaryData: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeeSalaryData}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeEmergencyContact: builder.mutation<
      unknown,
      PatchQueryArgsType
    >({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeeEmergencyContact}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeAdditionalData: builder.mutation<unknown, PatchQueryArgsType>(
      {
        query: ({ body, id }) => ({
          url: `${EMP_API.updateEmployeeAdditionalData}/${id}`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: (result, _, { id }) => {
          if (result)
            return [
              "GetUsers",
              // {
              //   type: "GetEmployeeDetails",
              //   id,
              // },
              {
                type: "GetSingleUser",
                id,
              },
            ];

          return [];
        },
      }
    ),
    updateEmployeeStatus: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.updateEmployeeStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            // {
            //   type: "GetEmployeeDetails",
            //   id,
            // },
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    updateEmployeeBulkStatus: builder.mutation({
      query: (body) => ({
        url: EMP_API.updateEmployeeBulkStatus,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetUsers",
            //  "GetEmployeeDetails",
            {
              type: "GetSingleUser",
            },
          ];

        return [];
      },
    }),
    bulkDeleteEmployees: builder.mutation({
      query: (body) => ({
        url: EMP_API.bulkDeleteEmployees,
        method: "POST",
        body,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
            },
          ];

        return [];
      },
    }),
    sendInvite: builder.mutation({
      query: (data) => ({
        url: EMP_API.sendInvite,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUsers"];

        return [];
      },
    }),
    uploadEmployeeBkashData: builder.mutation({
      query: (data) => ({
        url: EMP_API.uploadEmployeeBkashData,
        method: "PATCH",
        body: data,
      }),
    }),
    uploadPhotoInEmployee: builder.mutation({
      query: (data) => {
        return {
          url: EMP_API.uploadPhotoInEmployee,
          method: "PATCH",
          body: data,
        };
      },
    }),
    getBusinessData: builder.query<GetBusinessDataResponseType, string>({
      query: (id) => ({
        url: `${EMP_API.getBusinessData}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetBusinessData", id }],
    }),
    reInvited: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.reInvited}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    activeInvited: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.activeInvited}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
              id,
            },
          ];

        return [];
      },
    }),
    makeCompanyAdmin: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.makeCompanyAdmin}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
              id,
            },
            { type: "GetRoles", id },
          ];

        return [];
      },
    }),
    makeHRAdmin: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.makeHRAdmin}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
              id,
            },
            { type: "GetRoles", id },
          ];

        return [];
      },
    }),
    makeSuperAdmin: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${EMP_API.makeSuperAdmin}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetUsers",
            {
              type: "GetSingleUser",
              id,
            },
            { type: "GetRoles", id },
          ];

        return [];
      },
    }),
    roleStatus: builder.query<GetRoleStatusResponseType, string>({
      query: (id) => ({
        url: `${EMP_API.roleStatus}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetRoles", id }],
    }),
    deleteRole: builder.mutation<unknown, any>({
      query: (body) => ({
        url: EMP_API.deleteRole,
        method: "POST",
        body,
      }),
      invalidatesTags: (result) => {
        if (result)
          return ["GetUsers", "GetSingleUser", "GetRoles", "GetProjectsByUser"];

        return [];
      },
    }),
    deleteInvited: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `${EMP_API.deleteInvited}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetUsers"];

        return [];
      },
    }),
    downloadEmployeeDetails: builder.query({
      query: ({ id }) => ({
        url: `${EMP_API.downloadEmployeeDetails}/${id}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
      }),
    }),
    getEmployeesListExport: builder.query<
      GetEmployeesListExportResponseType,
      GetQueryArgsType<EmployeesListExportParams>
    >({
      query: (queryArgs) => ({
        url: EMP_API.getEmployeesListExport,
        params: {
          ...queryArgs,
        },
      }),
    }),

    getEmployeeManagementData: builder.query<
      GetEmployeeManagementDataResponseType,
      GetQueryArgsType<GetEmployeeManagementDataParamsType>
    >({
      query: (queryArgs) => ({
        url: EMP_API.getEmployeeManagementData,
        ...queryArgs,
      }),
      providesTags: ["GetUsers"],
    }),

    getGrade: builder.query<GetGradeResponseType, void>({
      query: () => ({
        url: EMP_API.getGrade,
      }),
      providesTags: ["GetGrade"],
    }),
    uploadGrossSalary: builder.mutation({
      query: (data) => ({
        url: EMP_API.uploadGrossSalary,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetEmployeeBreakdownSalaryDetails"];

        return [];
      },
    }),
    uploadAdditionDeductionSalary: builder.mutation({
      query: (data) => ({
        url: EMP_API.uploadAdditionDeductionSalary,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAdditionDeductionSalary"];

        return [];
      },
    }),
    getUserDetailsLog: builder.query<
      GetUserDetailsLog,
      GetQueryArgsType<GetUserDetailsLogParams>
    >({
      query: (params) => ({
        url: `${EMP_API.getUserDetailsLog}`,
        ...params,
      }),
      providesTags: () => [{ type: "GetSingleUser" }],
    }),
    getEmployeeBreakdownSalaryDetails: builder.query<
      GetEmployeeBreakdownSalaryDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${EMP_API.getEmployeeBreakdownSalaryDetails}/${id}`,
      }),
      providesTags: ["GetEmployeeBreakdownSalaryDetails"],
    }),
    updateSalaryDetails: builder.mutation({
      query: (data) => ({
        url: EMP_API.updateSalaryDetails,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetEmployeeBreakdownSalaryDetails"];
        return [];
      },
    }),
    uploadVariableSalary: builder.mutation({
      query: (data) => ({
        url: EMP_API.uploadVariableSalary,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetVariableSalary"];

        return [];
      },
    }),
    employeeReport: builder.mutation({
      query: (queryArgs) => ({
        url: EMP_API.employeeReport,
        method: "POST",
        ...queryArgs,
      }),
      invalidatesTags: ["GetReport"],
    }),
    getPayrollSetting: builder.query<PayrollSettingResponseType, void>({
      query: () => ({
        url: EMP_API.getPayrollSetting,
      }),
      providesTags: ["GetPayrollSetting"],
    }),
    downloadSalaryCertificate: builder.query<
      void,
      GetQueryArgsType<GetDownloadSalaryCertificateType>
    >({
      query: (queryArgs) => ({
        url: `${EMP_API.downloadSalaryCertificate}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
    getPayComponentSetting: builder.query<
      PayrollComponentResponseType,
      GetQueryArgsType<GetPayComponentParamsType>
    >({
      query: (queryArgs) => ({
        url: EMP_API.getPayComponentSetting,
        ...queryArgs,
      }),
      providesTags: ["GetPayComponentSetting"],
    }),
    getDisbursementBankKeywords: builder.query<
      GetDisbursementBankKeywordsResponseType,
      GetQueryArgsType<GetDisbursementBankKeywordsParamsType>
    >({
      query: (queryArgs) => ({
        url: EMP_API.getDisbursementBankKeywords,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetEmployeesQuery,
  useGetEmployeeDetailsQuery,
  useAddEmployeeMutation,
  useUpdateProfilePictureMutation,
  useUpdateEmployeeOfficialDataMutation,
  useUpdateEmployeePersonalDataMutation,
  useUpdateEmployeeFinancialDataMutation,
  useUpdateEmployeeSalaryDataMutation,
  useUpdateEmployeeEmergencyContactMutation,
  useUpdateEmployeeAdditionalDataMutation,
  useUpdateEmployeeStatusMutation,
  useUpdateEmployeeBulkStatusMutation,
  useBulkDeleteEmployeesMutation,
  useSendInviteMutation,
  useUploadEmployeeBkashDataMutation,
  useUploadPhotoInEmployeeMutation,
  useGetBusinessDataQuery,
  useActiveInvitedMutation,
  useDeleteInvitedMutation,
  useReInvitedMutation,
  useLazyDownloadEmployeeDetailsQuery,
  useGetEmployeesListExportQuery,
  useGetEmployeeManagementDataQuery,
  useGetMeQuery,
  useGetGradeQuery,
  useUploadGrossSalaryMutation,
  useDownloadEmployeeDetailsQuery,
  useUploadAdditionDeductionSalaryMutation,
  useGetUserDetailsLogQuery,
  useGetEmployeeBreakdownSalaryDetailsQuery,
  useUpdateSalaryDetailsMutation,
  useUploadVariableSalaryMutation,
  useEmployeeReportMutation,
  useGetPayrollSettingQuery,
  useLazyDownloadSalaryCertificateQuery,
  useGetPayComponentSettingQuery,
  useGetDisbursementBankKeywordsQuery,
  useMakeCompanyAdminMutation,
  useMakeSuperAdminMutation,
  useRoleStatusQuery,
  useDeleteRoleMutation,
  useMakeHRAdminMutation,
} = employeeApi;
